var _defs, _rect, _rect2, _rect3, _text, _rect4, _rect5, _text2, _h, _text3, _h2, _text4, _h3, _text5, _rect6, _rect7, _text6, _h4, _text7, _rect8, _h5, _text8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefEconomics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "703px",
    height: "197px",
    viewBox: "-0.5 -0.5 703 197",
    content: "<mxfile modified=\"2019-03-02T16:08:07.880Z\" host=\"www.draw.io\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/72.0.3626.119 Safari/537.36\" etag=\"qnAka_m-YzOFziBXzmqN\" version=\"10.3.1\" type=\"device\"><diagram name=\"Page-1\" id=\"fbcf5db9-b524-4cd4-e4f3-379dc89c3999\">7Vldb5swFP01PHbCmI/w2KTNpmlTpaXStEcXDFg1OHLchuzXz4AJBDsdU6Hq1PASfH39dc859jWx4CovP3O0zb6zGFPLsePSgjeW4wAX2vKnshwaSwCDxpByEiunzrAhv7EyqnbpE4nx7sRRMEYF2Z4aI1YUOBInNsQ525+6JYyejrpFKdYMmwhR3fqTxCJrrAvP7uxfMEmzdmRgq5oHFD2mnD0VajzLgUn9NNU5avtS/rsMxWzfM8FbC644Y6J5y8sVplVs27A17dZnao/z5rgQYxpsvh7uwKEsn8PEie7ygv76tbzyml6eEX3C7TLqyYpDG6B6ibjqBFhwuc+IwJstiqravaSEtGUip6p6Jzh7xCtGGa9bQz9a4IdE1iSE0p4d2AEM5TyXagKYC1yeXRk4xkvyELMcC36QLqpBG2HFQM9X5X2HZ9CilvWwdJUNKQqlx567MMoXFUlzVB1kJyF88KIA4mSBgyvnzSLa1LSkBXqMfX/prNeVnRVCKQ9AWUaUpIUsRDLAWDovU45iIgs3hEuNEVZVYrSTcVpWyBApl2vVRrBqgkcygyOEGl4GVMdC6BogPPr0IVx4M0AINQiBhqFcl3gJqIIVeICIMmnBH0Y4J3FcDWNkRg9KufM25R7k6/qZBhM4wCSEGiauARJnDlW1p8V8sgrrZ4ysjp5DWQ2waJ73KTf/PekNAA1cHd0PIDh5Sr0jxS0MivNpjYFchp9Wbz9wQgpcr2HF8i3FJRGH1k0O2XmOwVMGnhSpLHld6b7i/82VY5+Bh8nwJrTWRiZhxMU5YpzK2jVTpRVmD2DbDtbDQzR8gQca2yYgxlCtgafxAvgGYnhzqLXV5ovE+MYiVG9sjs1kQmzzjihIJswVExivMvMLVybmCgTDrd0dR5YgmIMsei6lk+V6t8PiwoSpmeCEw3vRYhwTpjhPjLfND3s3etX11rO1ZO2TfgDMlq4ZkdRlDf/TjO110Aw32xAaoJkrZzMi447YcO85KnZbxoU6oy87r7bzvo4W3t8TeePOC/2ZWOHPvfN2l+I3+87nA/3S6pqiOsV3PmNUgxFau9tiXssM0YvQphYaCIaUGJviOP9MCVnsPtbXdb1/RODtHw==</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106,
    width: 700,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#10739e",
    stroke: "#6c8ebf",
    pointerEvents: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6,
    width: 220,
    height: 85,
    rx: 12.75,
    ry: 12.75,
    fill: "#000000",
    stroke: "#000000",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6,
    width: 220,
    height: 85,
    rx: 12.75,
    ry: 12.75,
    fill: "#66b2ff",
    stroke: "#6c8ebf",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.5,31.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 16,
    height: 34,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 30,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      verticalAlign: "top",
      width: 18,
      whiteSpace: "nowrap",
      overflowWrap: "normal",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "1"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 32,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontSize: "30px",
    fontFamily: "Helvetica"
  }, "1")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 6,
    width: 220,
    height: 85,
    rx: 12.75,
    ry: 12.75,
    fill: "#000000",
    stroke: "#000000",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 6,
    width: 220,
    height: 85,
    rx: 12.75,
    ry: 12.75,
    fill: "#999999",
    stroke: "#999999",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(261.5,31.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 16,
    height: 34,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 30,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      verticalAlign: "top",
      width: 18,
      whiteSpace: "nowrap",
      overflowWrap: "normal",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "2"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 32,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontSize: "30px",
    fontFamily: "Helvetica"
  }, "2")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.5,10.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 150,
    height: 64,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      verticalAlign: "top",
      overflow: "hidden",
      maxHeight: 65,
      maxWidth: 150,
      width: 150,
      whiteSpace: "normal",
      overflowWrap: "normal",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _h || (_h = /*#__PURE__*/React.createElement("h1", null, "Refinery Complexity"))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 37,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontSize: "9px",
    fontFamily: "Helvetica"
  }, "&lt;h1&gt;Refinery Complexity&lt;/h1&gt;")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.5,-0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 150,
    height: 85,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      verticalAlign: "top",
      overflow: "hidden",
      maxHeight: 87,
      maxWidth: 150,
      width: 150,
      whiteSpace: "normal",
      overflowWrap: "normal",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _h2 || (_h2 = /*#__PURE__*/React.createElement("h1", null, "Location of refinery and storage"))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 47,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontSize: "9px",
    fontFamily: "Helvetica"
  }, "&lt;h1&gt;Location of refinery and storage&lt;/h1&gt;")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.5,103.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 49,
    height: 30,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      verticalAlign: "top",
      overflow: "hidden",
      maxHeight: 30,
      maxWidth: 150,
      width: 51,
      whiteSpace: "normal",
      overflowWrap: "normal",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _h3 || (_h3 = /*#__PURE__*/React.createElement("h1", null, "Asset"))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 20,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontSize: "9px",
    fontFamily: "Helvetica"
  }, "&lt;h1&gt;Asset&lt;/h1&gt;")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 6.5,
    width: 220,
    height: 85,
    rx: 12.75,
    ry: 12.75,
    fill: "#000000",
    stroke: "#000000",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 6.5,
    width: 220,
    height: 85,
    rx: 12.75,
    ry: 12.75,
    fill: "#66b2ff",
    stroke: "#6c8ebf",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.5,32.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 16,
    height: 34,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 30,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      verticalAlign: "top",
      width: 18,
      whiteSpace: "nowrap",
      overflowWrap: "normal",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "3"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 32,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontSize: "30px",
    fontFamily: "Helvetica"
  }, "3")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546.5,28.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 127,
    height: 43,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      verticalAlign: "top",
      overflow: "hidden",
      maxHeight: 46,
      maxWidth: 150,
      width: 127,
      whiteSpace: "normal",
      overflowWrap: "normal",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _h4 || (_h4 = /*#__PURE__*/React.createElement("h1", null, "Transportation"))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 26,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontSize: "9px",
    fontFamily: "Helvetica"
  }, "&lt;h1&gt;Transportation&lt;/h1&gt;")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 156,
    width: 460,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#10739e",
    stroke: "#999999",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.5,153.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 101,
    height: 32,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      verticalAlign: "top",
      overflow: "hidden",
      maxHeight: 32,
      maxWidth: 150,
      width: 101,
      whiteSpace: "normal",
      overflowWrap: "normal",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _h5 || (_h5 = /*#__PURE__*/React.createElement("h1", null, "Operational"))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 21,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontSize: "9px",
    fontFamily: "Helvetica"
  }, "&lt;h1&gt;Operational&lt;/h1&gt;"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefEconomics);
export default __webpack_public_path__ + "static/media/ref_economics.678eff2b3e3171cfc78aca620072b472.svg";
export { ForwardRef as ReactComponent };